
//------------------------------------------------------------------------------

const usePhoneVerification = (accountProvider)=>{
    
    const { requestPhoneCode, verifyPhone } = accountProvider;

    const sendCode = async (phoneNumber, phoneCountry) => {
        const { dialCode, iso2 } = phoneCountry;
        return requestPhoneCode
                .mutateAsync({ 
                    PhoneNumber: phoneNumber, 
                    PhoneCountryCode: dialCode, 
                    PhoneAlpha2Code: iso2 
                })
                .catch((error) => { throw error; });
    };

    const verifyCode = async (phoneNumber, phoneCountry, code) => {
        const { dialCode, iso2 } = phoneCountry;

        try {
            const result = await verifyPhone.mutateAsync({
                VerificationCode: code,
                PhoneNumber: phoneNumber,
                PhoneCountryCode: dialCode,
                PhoneAlpha2Code: iso2,
            });
            return result;
            
        } catch (error) {
            throw error;
        }
    };

    return {
        sendCode,
        verifyCode
    }

}

export default usePhoneVerification;